import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_RS.json';
import audios from './LOVE_AUDIOS_RS.json';

export const LOVE_DATA_RS: ServiceData = {
  articles,
  audios,
};
